// 倒计时或促销活动
import React, { useState } from 'react';
import Countdown from 'react-countdown';

export default function Discount(
  props: PriceTypes.Countdown & {
    i18n: DetailTypes.i18n;
  }
) {
  const { availableActivity, i18n } = props;
  const [complete, setComplete] = useState(false);

  if (!availableActivity) return null;

  const { endTime, promotionContent } = availableActivity;

  if (!endTime) return null;
  const renderCount = (data: {
    hours: any;
    minutes: any;
    seconds: any;
    days: any;
    completed: any;
  }) => {
    const { days, hours, minutes, seconds, completed } = data;
    setComplete(completed);
    return (
      <span className="active-date">
        {days}d:{hours}h:{minutes}m:{seconds}s
      </span>
    );
  };

  if (complete) return null;

  return (
    <div className="product-activity">
      <span className="active-percent">
        {i18n['undue_market_action.coupon.off']?.replace('{0}', `${promotionContent}%`)}
      </span>
      <span className="active-discount">{i18n['marketAction_activity_endTime']}</span>
      <Countdown date={endTime} renderer={renderCount} />
    </div>
  );
}
